import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'cc-lg-popup-font-box',
  templateUrl: './popup-font-box.component.html',
  styleUrls: ['./popup-font-box.component.scss']
})
export class PopupFontBoxComponent implements OnInit {
  @Input() popupSettings: FormGroup;

  constructor() {}

  ngOnInit() {}
}
